const renderMode = {
  normal: 'normal'
}

export default renderMode
